(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .factory('FormBuilderHelper', FormBuilderHelper);

    function FormBuilderHelper(lodash) {
        return {
            getElementSize: getElementSize,
            determineDisabled: determineDisabled
        };


        function getElementSize(elemObj, isLast) {
            //if (elemObj.type == 'button') {  }

            if (elemObj.type == 'hidden') return "hide";
            if (!lodash.has(elemObj, 'attr.size') && !lodash.has(elemObj, 'attr.class')) {
                return "small-12";
            }

            var smallSize = "small-12";
            var mediumSize = 'medium-' + lodash.get(elemObj, 'attr.size', 12);
            var endingClass = (lodash.get(elemObj, 'attr.end', true)) ? "end" : "";
            var additionalClass = lodash.get(elemObj, 'attr.class', '');

            if (isLast) endingClass = 'end';

            var startClass = (lodash.get(elemObj, 'attr.start', false)) ? "start" : "";
            return [startClass, smallSize, mediumSize, endingClass, additionalClass].join(' ');
        }

        function determineDisabled(disabled_fields_option, element, model) {
            if (!Array.isArray(disabled_fields_option)) {
                return null;
            }

            var disabled_field = lodash.find(disabled_fields_option, { 'target_field_name': element.name });
            if (!disabled_field) {
                return null;
            }

            var compared_value = lodash.get(model, disabled_field.source_field_name, null);
            if (compared_value === null) {
                return null;
            }

            return !(lodash.get(disabled_field, 'value_flip', false)) ? compared_value : !compared_value;
        }
    }
})();